import { useEffect, useState } from "react";
import Card from "../foundational/Card";
import Button from "../foundational/Button";
import { momentoEstudiante } from "../../lib/homeExplora";
import { haceCuanto, nombreDelBorrador } from "../pae-detallado/borradorPae";
import { retoHechoHoy, retoHechoLocal } from "../../lib/retoHecho";

// La card protagonista del estudiante en el inicio (I4 del plan de la interfaz
// de los tres mundos, decisión del fundador 2026-10-04). Va en el MISMO lugar
// del DOM que EL MOMENTO del enfermero: es su "qué hago ahora".
//   1. Un PAE sin terminar en este dispositivo → seguirlo o descartarlo, con
//      el texto del aviso de siempre, que con esta card no se repite arriba.
//   2. Si ya hizo el reto de hoy (en cualquier aparato: sigue a la cuenta),
//      "Arma un PAE" en PAE Rápido. Mismas palabras que la racha.
//   3. Si no, el reto del día.
// Es navegación: cero háptica. Anti-culpa: un borrador viejo se describe
// ("Hace 3 h"), jamás se reprocha.
export default function MomentoEstudiante({ userId, borrador, onContinuarBorrador, onDescartarBorrador, onAbrirReto, onArmarPae }) {
  // El espejo local responde al tiro; la cuenta confirma después. Mientras la
  // cuenta no conteste se muestra el reto, que es lo de siempre.
  const [retoHecho, setRetoHecho] = useState(() => retoHechoLocal(userId));
  useEffect(() => {
    let vigente = true;
    setRetoHecho(retoHechoLocal(userId));
    if (userId) retoHechoHoy(userId).then((hecho) => { if (vigente) setRetoHecho(hecho); });
    return () => { vigente = false; };
  }, [userId]);

  const momento = momentoEstudiante({ borrador, retoHecho });

  if (momento.tipo === "borrador") {
    return (
      <section aria-label="Tu momento" className="mt-6">
        <Card variant="protagonista" padding="lg">
          <p className="flex items-center gap-2 text-micro uppercase tracking-wide font-semibold font-sans text-accent mb-2.5">
            <span aria-hidden="true" className="w-1.5 h-1.5 rounded-full bg-accent flex-shrink-0" />
            Tu PAE
          </p>
          {/* Las mismas palabras del aviso del borrador de App (coherencia:
              mismo concepto, mismo texto en todas las superficies). */}
          <h2 className="text-h2 font-serif text-ink leading-snug">{nombreDelBorrador(borrador)} sin terminar</h2>
          <p className="mt-2 text-body text-ink-subtle font-sans leading-relaxed">
            {haceCuanto(momento.timestamp)}. ¿Continuar donde lo dejaste?
          </p>
          <div className="mt-4 flex flex-wrap items-center gap-2.5">
            <Button size="lg" className="min-h-[44px]" onClick={onContinuarBorrador}>
              Continuar
            </Button>
            {onDescartarBorrador && (
              <Button variant="ghost" size="lg" className="min-h-[44px]" onClick={onDescartarBorrador}>
                Descartar
              </Button>
            )}
          </div>
        </Card>
      </section>
    );
  }

  if (momento.tipo === "pae") {
    // Anti-culpa y sin empujar: se dice lo hecho y se ofrece seguir, "si quieres".
    return (
      <section aria-label="Tu momento" className="mt-6">
        <Card variant="protagonista" padding="lg">
          <p className="flex items-center gap-2 text-micro uppercase tracking-wide font-semibold font-sans text-accent mb-2.5">
            <span aria-hidden="true" className="w-1.5 h-1.5 rounded-full bg-accent flex-shrink-0" />
            Para hoy
          </p>
          <h2 className="text-h2 font-serif text-ink leading-snug">Arma un PAE</h2>
          <p className="mt-2 text-body text-ink-subtle font-sans leading-relaxed">
            Ya hiciste el reto de hoy. Si quieres seguir, practica con un caso en PAE Rápido.
          </p>
          <div className="mt-4">
            <Button size="lg" className="min-h-[44px]" onClick={onArmarPae}>
              Empezar un PAE
            </Button>
          </div>
        </Card>
      </section>
    );
  }

  return (
    <section aria-label="Tu momento" className="mt-6">
      <Card variant="protagonista" padding="lg">
        <p className="flex items-center gap-2 text-micro uppercase tracking-wide font-semibold font-sans text-accent mb-2.5">
          <span aria-hidden="true" className="w-1.5 h-1.5 rounded-full bg-accent flex-shrink-0" />
          Para hoy
        </p>
        <h2 className="text-h2 font-serif text-ink leading-snug">El reto del día</h2>
        <p className="mt-2 text-body text-ink-subtle font-sans leading-relaxed">
          Cinco preguntas cortas para repasar, del mismo banco que Modo estudio.
        </p>
        <div className="mt-4">
          <Button size="lg" className="min-h-[44px]" onClick={onAbrirReto}>
            Hacer el reto
          </Button>
        </div>
      </Card>
    </section>
  );
}
